<template class="ContactMobile">
    <main class="container_contact_mobile" id="contact_mobile">
        <!-- section top -->
        <section class="container_contact_mobile__section_top">
            <!-- article top -->
            <article class="container_contact_mobile__section_top__article_top">
                <aside class="container_contact_mobile__section_top__article_top__aside">
                    <div class="container_contact_mobile__section_top__article_top__aside__div">
                        <h1 class="container_contact_mobile__section_top__article_top__aside__div__h1">
                            Me contacter
                        </h1>
                    </div>
                </aside>
            </article>
            <!-- article bottom -->
            <article class="container_contact_mobile__section_top__article_bottom">
                <form action="post" class="container_contact_mobile__section_top__article_bottom__form">
                    <!-- aside top -->
                    <aside class="container_contact_mobile__section_top__article_bottom__form__aside_top">
                        <div class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_1">
                            <input type="text" name="name" placeholder="Nom..."
                                class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_1__input"
                                :value="inputFieldReset" required>
                        </div>
                        <div class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_2">
                            <input type="text" name="firstname" placeholder="Prénom..."
                                class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_2__input"
                                :value="inputFieldReset" required>
                        </div>
                        <div class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_3">
                            <input type="text" name="object" placeholder="Objet..."
                                class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_3__input"
                                :value="inputFieldReset" required>
                        </div>
                        <div class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_4">
                            <button style="display:block;" onclick="document.getElementById('getFile').click()"
                                class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_4__button">Joindre
                                fichier</button>
                            <input type='file' id="getFile" style="display:none"
                                class="container_contact_mobile__section_top__article_bottom__form__aside_top__div_4__input">
                        </div>
                    </aside>
                    <!-- aside middle -->
                    <aside class="container_contact_mobile__section_top__article_bottom__form__aside_middle">
                        <div class="container_contact_mobile__section_top__article_bottom__form__aside_middle__div">
                            <textarea name="message" id="message" cols="30" rows="10" placeholder="Message..."
                                class="container_contact_mobile__section_top__article_bottom__form__aside_middle__div__textarea"
                                :value="inputFieldReset" required>
                            </textarea>
                        </div>
                    </aside>
                    <!-- aside bottom -->
                    <aside class="container_contact_mobile__section_top__article_bottom__form__aside_bottom">
                        <!-- div left -->
                        <div
                            class="container_contact_mobile__section_top__article_bottom__form__aside_bottom__div_left">
                            <input type="submit" name="envoyer" id="envoyer" value="Envoyer"
                                class="container_contact_mobile__section_top__article_bottom__form__aside_bottom__div_left__input">
                        </div>
                        <!-- div right -->
                        <div
                            class="container_contact_mobile__section_top__article_bottom__form__aside_bottom__div_right">
                            <input type="reset" name="annuler" id="annuler" value="Annuler"
                                class="container_contact_mobile__section_top__article_bottom__form__aside_bottom__div_right__input">
                        </div>
                    </aside>
                </form>
            </article>
        </section>
        <!-- section bottom -->
        <section class="container_contact_mobile__section_bottom">
            <article class="container_contact_mobile__section_bottom__article">
                <!-- aside top -->
                <aside class="container_contact_mobile__section_bottom__article__aside_top">
                    <div class="container_contact_mobile__section_bottom__article__aside_top__div">
                        <h1 class="container_contact_mobile__section_bottom__article__aside_top__div__h1">
                            Localisation
                        </h1>
                    </div>
                    <!-- div icon -->
                    <div class="container_contact_mobile__section_bottom__article__aside_top__div_icon">
                        <img src="@/assets/map-icon.png" alt="map icon"
                            class="container_contact_mobile__section_bottom__article__aside_top__div_icon__img">
                    </div>
                </aside>
                <!-- aside bottom -->
                <aside class="container_contact_mobile__section_bottom__article__aside_bottom">
                    <div class="container_contact_mobile__section_bottom__article__aside_bottom__div">
                        <img src="@/assets/Ardèche-Position.svg" alt="Ardeche Position"
                            class="container_contact_mobile__section_bottom__article__aside_bottom__div__img">
                    </div>
                </aside>
            </article>
        </section>
    </main>
</template>

<script >
export default {
    name: 'ContactMobile',
}
</script>

<style  lang=scss scoped>
@import "@/style/components/Contact/ContactMobile.scss";


@media screen and(min-width: 926px) {
    #contact_mobile {
        display: none;
    }
}
</style>